import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { OtherCharge } from '@/class/model/booking/OtherCharge'
import * as NumberUtils from '@/utils/NumberUtils'
import { AirCargoDoc } from '@/class/model/booking/AirCargoDoc'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'

export class AirExportUtils {
  // 填充提单的其他费用
  static async fillMAWBInfoOtherCharge(job, cargoDoc, mawbInfoOtherCharge) {
    if (mawbInfoOtherCharge && mawbInfoOtherCharge.length > 0) {
      if (cargoDoc.uuid) {
        await new AirCargoDoc(cargoDoc).getOtherCharge()
      }
      if (cargoDoc.otherCharge && cargoDoc.otherCharge.length > 0) {
        for (let i = 0; i < cargoDoc.otherCharge.length; i++) {
          const item = cargoDoc.otherCharge[i]
          if (item.uuid) {
            item.deleted = true
          } else {
            cargoDoc.otherCharge.splice(i, 1)
          }
        }
      } else {
        cargoDoc.otherCharge = []
      }
      if (cargoDoc.other === AirExportConstants.PP) {
        cargoDoc.pp5 = ''
      } else if (cargoDoc.other === AirExportConstants.CC) {
        cargoDoc.cc5 = ''
      }
      let lclJob = false
      // 主票 无小票不添加job费用
      if (job.masterFlag && (!job.lclSlaves || job.lclSlaves.length === 0)) {
        lclJob = true
      }
      for (const otherCharge of mawbInfoOtherCharge) {
        if (!(lclJob && otherCharge.measure === 'job')) {
          const oc = new OtherCharge().fillDefaultValue().getData()
          oc.deleted = false
          oc.airCargoDocUuid = cargoDoc.uuid
          oc.minAmount = otherCharge.minAmount
          oc.chargeItem = otherCharge.chargeItem
          oc.unitRate = otherCharge.unitRate
          oc.measure = otherCharge.measure
          oc.remark = otherCharge.remark
          oc.amount = 0
          this.refreshMAWBAmount(job, cargoDoc, oc)
          if (cargoDoc.other === AirExportConstants.PP) {
            cargoDoc.pp5 = NumberUtils.formatNumber(this.number(cargoDoc.pp5) + Number(oc.amount), 2) + ''
            cargoDoc.cc5 = ''
            cargoDoc.pp6 = NumberUtils.formatNumber(this.number(cargoDoc.pp1) + this.number(cargoDoc.pp2) + this.number(cargoDoc.pp3) + this.number(cargoDoc.pp4) + this.number(cargoDoc.pp5), 2) + ''
          } else if (cargoDoc.other === AirExportConstants.CC) {
            cargoDoc.cc5 = NumberUtils.formatNumber(this.number(cargoDoc.cc5) + Number(oc.amount), 2) + ''
            cargoDoc.pp5 = ''
            cargoDoc.cc6 = NumberUtils.formatNumber(this.number(cargoDoc.cc1) + this.number(cargoDoc.cc2) + this.number(cargoDoc.cc3) + this.number(cargoDoc.cc4) + this.number(cargoDoc.cc5), 2) + ''
          }
          cargoDoc.otherCharge.push(oc)
        }
      }
    }
  }
  // 刷新费用金额
  static refreshMAWBAmount(job, cargoDoc, charge) {
    const cWeight = isNaN(cargoDoc.cWeight) ? 0 : cargoDoc.cWeight
    const weight = isNaN(cargoDoc.weight) ? 0 : cargoDoc.weight
    const quantity = isNaN(cargoDoc.quantity) ? 0 : cargoDoc.quantity
    switch (charge.measure) {
      case 'chargeWeight' :
        charge.amount = cWeight * charge.unitRate
        break

      case 'job' :
        // CARGO-8990 迅霆空出Other Charge信息没有带入齐全
        var amount = charge.unitRate
        if (job.operateType === 0 && job.masterFlag && job.lclSlaves != null) {
          const l = job.lclSlaves.length
          if (l > 0) {
            amount = charge.unitRate * l
          }
        }
        charge.minAmount = amount
        charge.amount = amount
        break

      case 'wt' :
        charge.amount = weight * charge.unitRate
        break

      case 'quantity' :
        charge.amount = quantity * charge.unitRate
        break

      case AirExportConstants.GENERAL_CHARGE.code:
        charge.amount = charge.unitRate
        break

      default : break
    }
    // 如果最低费用为50块，不到50的都需要以50来计费
    if (charge.minAmount > 0 && charge.amount < charge.minAmount) {
      charge.amount = charge.minAmount
    }
  }
  static refreshCargoDoc(cargoDoc, charges) {
    let pp5 = 0
    let cc5 = 0
    if (charges && charges.length > 0) {
      for (const charge of charges) {
        const amount = isNaN(charge.amount) ? 0 : charge.amount
        if (cargoDoc.other === AirExportConstants.PP) {
          pp5 += Number(amount)
        } else if (cargoDoc.other === AirExportConstants.CC) {
          cc5 += Number(amount)
        }
      }
    }
    // CARGO-36728 恩跃：空运HAWB页面 Total other Charges Due Agent可以为空
    const isHawb = cargoDoc.docType === CargoDocConsts.HAWB
    if (!isHawb) { // MAWB
      if (cargoDoc.other === AirExportConstants.PP) {
        cargoDoc.pp5 = pp5 ? NumberUtils.formatNumber(pp5, 2) + '' : ''
        cargoDoc.cc5 = ''
        cargoDoc.pp6 = NumberUtils.formatNumber(this.number(cargoDoc.pp1) + this.number(cargoDoc.pp2) + this.number(cargoDoc.pp3) + this.number(cargoDoc.pp4) + this.number(cargoDoc.pp5), 2)
      } else if (cargoDoc.other === AirExportConstants.CC) {
        cargoDoc.cc5 = cc5 ? NumberUtils.formatNumber(cc5, 2) + '' : ''
        cargoDoc.pp5 = ''
        cargoDoc.cc6 = NumberUtils.formatNumber(this.number(cargoDoc.cc1) + this.number(cargoDoc.cc2) + this.number(cargoDoc.cc3) + this.number(cargoDoc.cc4) + this.number(cargoDoc.cc5), 2)
      }
    } else { // HAWB
      if (cargoDoc.other === AirExportConstants.PP) {
        cargoDoc.pp4 = pp5 ? NumberUtils.formatNumber(pp5, 2) + '' : ''
        cargoDoc.cc4 = ''
        cargoDoc.pp6 = NumberUtils.formatNumber(this.number(cargoDoc.pp1) + this.number(cargoDoc.pp2) + this.number(cargoDoc.pp3) + this.number(cargoDoc.pp4) + this.number(cargoDoc.pp5), 2)
      } else if (cargoDoc.other === AirExportConstants.CC) {
        cargoDoc.cc4 = cc5 ? NumberUtils.formatNumber(cc5, 2) + '' : ''
        cargoDoc.pp4 = ''
        cargoDoc.cc6 = NumberUtils.formatNumber(this.number(cargoDoc.cc1) + this.number(cargoDoc.cc2) + this.number(cargoDoc.cc3) + this.number(cargoDoc.cc4) + this.number(cargoDoc.cc5), 2)
      }
    }
  }
  static number(n) {
    if (n === 'null' || !n) {
      n = ''
    }
    if (n.indexOf(',') >= 0) {
      n = n.split(',').join('')
    }
    return isNaN(n) ? 0 : Number(n)
  }
  static refMawbInfo(job, cargoDoc, mawbInfo) {
    cargoDoc.accountCode = mawbInfo.accountNo
    cargoDoc.accountingInfo = mawbInfo.accountInfo
    cargoDoc.handingInfo = mawbInfo.handingInfo
    cargoDoc.iataCode = mawbInfo.iataCode
    cargoDoc.notifyLine1 = mawbInfo.carrierAgentCity
    cargoDoc.insuredAmount = mawbInfo.insuredAmount
    cargoDoc.issuedBy = mawbInfo.issuedBy
    this.fillMAWBInfoOtherCharge(job, cargoDoc, mawbInfo.mawbInfoOtherCharge)
  }
  static mawbNoDispalyFormat(mawbNo, isP = true) {
    if (mawbNo && mawbNo.length === 11) {
      mawbNo = mawbNo.substr(0, 3) + '-' + mawbNo.substr(3, 11)
    }
    return mawbNo
  }
  static validateMAWBNum(mbl = '') {
    let text = mbl
    let valid = true
    if (text && (text.length === 11 || text.length === 8)) {
      if (text.length === 11) {
        text = text.substr(3)
      }
      const before7 = parseInt(text.substring(0, 7))
      const last = parseInt(text.substring(7))
      valid = before7 % 7 === last
    } else {
      valid = false
    }
    return valid
  }
  static validateMAWBNumIgnoreZeroOrThree(mbl = '') {
    let text = mbl.replace(/-/g, '')
    let valid = true
    if (text.length === 11 || text.length === 8) {
      if (text.length === 11) {
        text = text.substr(3)
      }
      const before7 = parseInt(text.substring(0, 7))
      const last = parseInt(text.substring(7))
      valid = before7 % 7 === last
    } else if (text.length !== 3) {
      // 如果不是长度为8, 11或3，设置 `valid` 为 `false`
      valid = false
    }
    return valid
  }
  /**
	 * 要跟起始主单号和数量生成主单明细
	 * 生成规律为每次加11，末尾遇7归0.
	 * @param startMAWBNum
	 * @return 主单明细
	 */
  static generateMAWBNums(startMAWBNum, count) {
    const noArray = []
    if (this.validateMAWBNum(startMAWBNum) && count > 0) {
      let prefix = ''
      if (startMAWBNum.length === 11) {
        prefix = startMAWBNum.substr(0, 3)
        startMAWBNum = startMAWBNum.substr(3)
      }
      let cursor = parseInt(startMAWBNum)
      do {
        var s = this.fill(String(cursor))
        var b7 = parseInt(s.substr(0, 7))
        var l1 = parseInt(s.substr(7))
        if (l1 === 7) { l1 = 0 }
        cursor = parseInt(b7 + '' + l1)
        noArray.push(prefix + '' + this.fill(String(cursor)))
        cursor += 11
      }
      while (noArray.length < count)
    }
    return noArray
  }
  /**
	 * 位数不足补0
	 */
  static fill(s, len = 8) {
    if (s.length < len) {
      len = len - s.length
      for (let i = 0; i < len; i++) {
        s = '0' + s
      }
    }
    return s
  }

  // 刷新主票实际件毛体计费重量
  static updateActualQWCByAllSubJob(job) {
    if (job && job.masterFlag && job.lclSlaves && job.lclSlaves.length > 0) {
      let quantityActual = 0
      let weightActual = 0
      let cubageActual = 0
      let cWeight = 0
      for (const slave of job.lclSlaves) {
        quantityActual += slave.quantityActual
        if (!isNaN(slave.weightActual)) { weightActual += slave.weightActual }
        if (!isNaN(slave.cubageActual)) { cubageActual += slave.cubageActual }
        if (!isNaN(slave.cWeight)) { cWeight += slave.cWeight }
      }
      job.quantityActual = quantityActual
      job.weightActual = weightActual
      job.cubageActual = cubageActual
      job.cWeight = cWeight
    }
  }
}
